// Erfasst den Supabase-Bestaetigungs-Marker aus dem URL-Hash so frueh wie moeglich,
// bevor der Supabase-Client den Hash entfernt. Eine Signup-Bestaetigung landet auf
// dem Origin mit #...&type=signup. Wird fuer das einmalige CompleteRegistration-Event benoetigt.
export const IS_SIGNUP_CONFIRM_REDIRECT =
  typeof window !== 'undefined' &&
  /(^|[#&])type=signup(&|$)/.test(window.location.hash);

if (typeof window !== 'undefined') {
  (window as unknown as { __aimupSignupConfirm?: boolean }).__aimupSignupConfirm =
    IS_SIGNUP_CONFIRM_REDIRECT;
}
